import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const _8x8 = defineConnector({
  identifier: "_8x8",
  name: "8x8",
  tagLine: "Business communications platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.8x8\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an 8x8 app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [8x8 developer portal](https://developer.8x8.com/connect/) and create a server-to-server app for Connect APIs. Copy the client ID and client secret from the app settings before you continue.",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.8x8.com/oauth/v2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: { protocol: "http", request: () => "https://api.8x8.com/" },
});
